import type { ApiFlow } from '../types'

export const webServerOidcFlow: ApiFlow = {
  id: 'web.server-oidc',
  appTypes: ['web'],
  title: 'Server-side OIDC (confidential client)',
  summary:
    'Server redirects the browser to authorize, handles the callback, and exchanges the code with client_secret.',
  steps: [
    {
      id: 'discovery',
      title: 'Discovery',
      when: 'Server boot',
      method: 'GET',
      path: '/.well-known/openid-configuration',
      responseVariants: [
        {
          label: 'success',
          status: 200,
          body: {
            authorization_endpoint: '{{ISSUER}}/oauth2/auth',
            token_endpoint: '{{ISSUER}}/oauth2/token',
          },
          nextStepId: 'authorize',
        },
      ],
    },
    {
      id: 'authorize',
      title: 'Authorize redirect',
      when: 'User hits /login on your server',
      method: 'GET',
      path: '/oauth2/auth',
      query: {
        response_type: 'code',
        client_id: '{{CLIENT_ID}}',
        redirect_uri: '{{REDIRECT_URI}}',
        scope: 'openid profile',
        state: '<server-stored-csrf>',
      },
      responseVariants: [
        {
          label: 'redirect',
          status: 302,
          body: { note: 'Browser completes login; server callback receives code' },
          nextStepId: 'token',
        },
      ],
    },
    {
      id: 'token',
      title: 'Exchange code (confidential)',
      when: 'Callback route on your server',
      method: 'POST',
      path: '/oauth2/token',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      requestBody: {
        grant_type: 'authorization_code',
        code: '<code>',
        redirect_uri: '{{REDIRECT_URI}}',
        client_id: '{{CLIENT_ID}}',
        client_secret: '<server-side-secret>',
      },
      responseVariants: [
        {
          label: 'success',
          status: 200,
          body: {
            access_token: 'eyJ...',
            refresh_token: '...',
            id_token: 'eyJ...',
          },
        },
      ],
    },
  ],
}
